export default __webpack_public_path__ + "static/media/screen6.129f9fd6.png";